// extracted by mini-css-extract-plugin
export default {"root":"QuiddityPostItsOutput_root__lpZxM","body":"QuiddityPostItsOutput_body__U4ml1","selectedIcon":"QuiddityPostItsOutput_selectedIcon__0uEci"};